<template>
  <div class="myviedo">
    <div class="title">
      <h2>我的训练</h2>
    </div>

    <div class="sea">
      <span>训练列表</span>
      <div class="find">
        <input type="text" placeholder="请输入关键字" v-model="key" />
        <button class="ban" @click="findbtn">搜索</button>
      </div>
    </div>

    <div class="box">
      <a-table
        :columns="columns"
        :data-source="list"
        :rowKey="(record) => record.id"
        @change="changePage"
        :locale="{ emptyText: '暂无数据' }"
        bordered
      >
        <div slot="examtime" slot-scope="index, record">
          {{formatSeconds(record.examtime*60)}}
        </div>
        <div slot="status" slot-scope="index, record">
          <span v-if="record.status == 0">否</span>
          <span v-else>是</span>
        </div>
        <div slot="action" class="tableAction" slot-scope="index, record">
          <span @click="toDetail(record.id,record.formedBy)">查看</span>
        </div>
      </a-table>
    </div>

    <div class="pagemodel">
      <pagination
        :pagination="pagination"
        @changePage="changePage"
      ></pagination>
    </div>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    width: 70,
  },
  {
    title: "训练名称",
    dataIndex: "examtitle",
    width: 200,
  },
  {
    title: "专业方向",
    dataIndex:"model"
  },
  {
    title: "教学模块",
    dataIndex: "submodel",
  },
  {
    title: "成绩",
    dataIndex: "thscore",
  },{
    title: "答题时长",
    scopedSlots: { customRender: "examtime" },
  },
  {
    title: "是否合格",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
  },
];
import {formatSeconds} from "@/units/formatSeconds"
import pagination from "@/components/common/pagination";
import {getexamlistApi} from "@/request/api"
export default {
  name: "myviedo",
  components: { pagination },
  data() {
    return {
      columns,
      loadshow: true,
      nostartshow: false,
      finishshow: false,
      searchInfo: {
        page: 1,
        pageSize: 10,
        majorId:'',
        keyword:''
      },
      pagination: { total: "", pageSize: 10 },
      list: [],
      key:''
    };
  },
  created() {
    this.init();
  },
  methods: {
    formatSeconds,
    init() {
      this.getToken(getexamlistApi, this.searchInfo, (res) => {
        this.list = res.data.rows.map((item, index) => ({
          "index": (this.searchInfo.page - 1) * 10 + index + 1,
          "examtitle": item.paper.title,
          "model": item.paper.majors[0].name,
          "submodel": item.paper.majors[1].name,
          "thscore": item.theoryScore,
          "examtime":item.timeUse,
          "status":item.passed,
          "id": (item.paper.formedBy==2)?item.id:item.paper.id,
          "formedBy":item.paper.formedBy
        }));
        this.pagination.total = res.data.count;
      });
    },
    //分页
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.init();
    },
    //搜索
    findbtn() {
      this.searchInfo.keyword = this.key;
      this.init();
    }, 
    //查看
    toDetail(id,formedBy){
      // console.log(id)
       this.$router.push({path:'/watchexam',query:{paperId:this.$Base64.encode(id),formedBy:this.$Base64.encode(formedBy)}})
    }                                               
  },
};
</script>
<style>
.myviedo .ant-table table {
  text-align: center;
}
.myviedo thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
}
.myviedo .ant-table-bordered .ant-table-thead > tr > th,
.myviedo .ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e8e8e8;
  text-align: center;
}
.myviedo .ant-table-thead > tr > th {
  color: #333;
  font-weight: 600;
  font-size: 14px;
  /* background-color: #eaeef7; */
  height: 30px;
}
.myviedo .ant-table-bordered .ant-table-tbody {
  background: #fff;
}
.myviedo .ant-table-pagination.ant-pagination {
  text-align: center;
  margin: 0px auto;
  margin-top: 50px;
  display:none
}
.myviedo .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  padding: 10px 10px;
}

</style>
<style lang="stylus" scoped>
.myviedo {
  margin-bottom: 40px;

  .title {
    height: 45px;
    line-height: 45px;
    overflow: hidden;
    border-bottom: 1px solid #eff2f2;

    h2 {
      height: 45px;
      line-height: 45px;
      margin-left: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
  }

  .sea {
    height: 45px;
    margin-left: 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    position: relative;
    justify-content: space-between;

    span {
      color: #333;
      font-size: 16px;
    }

    .find {
      display: flex;
      margin-right: 30px;

      .mod {
        width: 204px;
        height: 35px;
        line-height: 35px;
        margin-right: 24px;

        .selbtn {
          width: 100%;
          height: 100%;
        }
      }

      input {
        outline: none;
        width: 220px;
        height: 35px;
        border: solid 1px #d4d4d4;
        text-indent: 8px;
      }

      .ban {
        outline: none;
        width: 60px;
        height: 35px;
        background-color: #f1ce48;
        color: #333;
        font-size: 14px;
        cursor: pointer;
        border: 0;
      }
    }
  }
  .box {
    margin-top: 30px;
    margin-left: 30px;
    margin-right: 30px;
  }

  .pagemodel {
    margin-top: 40px;
  }
}
</style>
